export default __webpack_public_path__ + "static/total-do-ef59be3c39957810f0ce558130814c3d.png";